<template>
  <b-container fluid>
    <h3>Unapproved Tax Exempt Forms</h3>
    <b-table :fields="fields" :items="customers" v-if="!!customers && customers.length > 0">
      <template slot="email" slot-scope="data">
        <router-link target="_blank" :to="{ name: 'Customer Lookup', query: { id: data.item.id.split('/').at(-1) } }">
          {{ data.item.email }}
        </router-link>
      </template>
    </b-table>
    <div v-else-if="customers.length === 0">
      No tax exempt forms to do. Have a cookie! 🍪
    </div>
  </b-container>
</template>

<script>
import shopifyService from '../../services/shopify'

export default {
  data() {
    return {
      fields: [
        { key: 'email' },
        { key: 'displayName', label: 'Name' },
        { key: 'note' },
      ],
      customers: undefined,
    };
  },
  mounted() {
    shopifyService.fetchTaxTodoCustomers().then((response) => {
      this.customers = response
    }).catch(e => console.error(e))
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customers/TaxTodo.vue